import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { authAPI } from '../services/api';
import { Modal, Button } from './Common';
import { BASE_URL } from '../config';

const ProfileDropdown = ({ user, onUpdate }) => {
  const [open,        setOpen]        = useState(false);
  const [showAccount, setShowAccount] = useState(false);
  const [showSettings,setShowSettings]= useState(false);
  const [saving,      setSaving]      = useState(false);
  const [bizFields, setBizFields] = useState(user?.business_fields || []);
  const [savingBiz, setSavingBiz] = useState(false);
  const [billFields, setBillFields] = useState(user?.bill_fields || [
    { label: 'GST', type: 'percent', value: '18' },
    { label: 'Discount', type: 'percent', value: '0' },
  ]);
  const [savingBill, setSavingBill] = useState(false);
  const [logoUploading, setLogoUploading] = useState(false);
  const [upiUploading, setUpiUploading] = useState(false);

  const [profileForm, setProfileForm] = useState({
    name:      user?.name      || '',
    shop_name: user?.shop_name || '',
    email:     user?.email     || '',
    address:   user?.address   || '',
    city:      user?.city      || '',
  });

  const [passForm, setPassForm] = useState({
    old_password: '', new_password: '', confirm_password: '',
  });

  const [phoneForm, setPhoneForm] = useState({
    phone:    user?.phone    || '',
    whatsapp: user?.whatsapp || '',
  });

  // Avatar initials
  const initials = (user?.name || 'A').split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2);

  // Subscription status color
  const subColor = user?.subscription_status === 'active' ? 'var(--accent2)'
    : user?.subscription_status === 'trial' ? 'var(--accent4)'
    : 'var(--danger)';

  const handleUpdateProfile = async () => {
    setSaving(true);
    try {
      const res = await authAPI.updateProfile(profileForm);
      toast.success('Profile update ho gaya! ✅');
      // LocalStorage update karo
      const saved = JSON.parse(localStorage.getItem('bhamsa_user') || '{}');
      localStorage.setItem('bhamsa_user', JSON.stringify({ ...saved, ...res.data.user }));
      if (onUpdate) onUpdate(res.data.user);
      setShowAccount(false);
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error aaya');
    } finally { setSaving(false); }
  };

  const handleChangePassword = async () => {
    if (passForm.new_password !== passForm.confirm_password) {
      toast.error('Naya password match nahi kar raha!'); return;
    }
    if (passForm.new_password.length < 6) {
      toast.error('Password kam se kam 6 characters ka hona chahiye'); return;
    }
    setSaving(true);
    try {
      await authAPI.changePassword({
        old_password: passForm.old_password,
        new_password: passForm.new_password,
      });
      toast.success('Password change ho gaya! ✅');
      setPassForm({ old_password: '', new_password: '', confirm_password: '' });
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error aaya');
    } finally { setSaving(false); }
  };

  const handleChangePhone = async () => {
    if (!phoneForm.phone) {
      toast.error('Phone number required hai'); return;
    }
    setSaving(true);
    try {
      await authAPI.changePhone(phoneForm);
      toast.success('Phone number update ho gaya! ✅');
      const saved = JSON.parse(localStorage.getItem('bhamsa_user') || '{}');
      localStorage.setItem('bhamsa_user', JSON.stringify({ ...saved, ...phoneForm }));
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error aaya');
    } finally { setSaving(false); }
  };

  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setLogoUploading(true);
    try {
      const formData = new FormData();
      formData.append('logo', file);
      const res = await authAPI.uploadLogo(formData);
      toast.success('Logo upload ho gaya! ✅');
      const saved = JSON.parse(localStorage.getItem('bhamsa_user') || '{}');
      const updated = { ...saved, logo: res.data.logo };
      localStorage.setItem('bhamsa_user', JSON.stringify(updated));
      if (onUpdate) onUpdate({ logo: res.data.logo });
    } catch (err) {
      toast.error(err.response?.data?.message || 'Logo upload failed');
    } finally { setLogoUploading(false); }
  };
  const handleUpiUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUpiUploading(true);
    try {
      const formData = new FormData();
      formData.append('upi_qr', file);
      const res = await authAPI.uploadUpiQr(formData);
      toast.success('UPI QR upload ho gaya! ✅');
      const saved = JSON.parse(localStorage.getItem('bhamsa_user') || '{}');
      localStorage.setItem('bhamsa_user', JSON.stringify({ ...saved, upi_qr: res.data.upi_qr }));
      if (onUpdate) onUpdate({ upi_qr: res.data.upi_qr });
    } catch (err) {
      toast.error(err.response?.data?.message || 'UPI QR upload failed');
    } finally { setUpiUploading(false); }
  };

  const handleAddField = () => {
    setBizFields([...bizFields, { label: '', value: '' }]);
  };

  const handleFieldChange = (index, key, val) => {
    const updated = [...bizFields];
    updated[index][key] = val;
    setBizFields(updated);
  };

  const handleRemoveField = (index) => {
    setBizFields(bizFields.filter((_, i) => i !== index));
  };

  const handleSaveBizFields = async () => {
    setSavingBiz(true);
    try {
      await authAPI.updateProfile({ ...profileForm, business_fields: bizFields });
      toast.success('Business details save ho gayi! ✅');
      const saved = JSON.parse(localStorage.getItem('bhamsa_user') || '{}');
      localStorage.setItem('bhamsa_user', JSON.stringify({ ...saved, business_fields: bizFields }));
      if (onUpdate) onUpdate({ business_fields: bizFields });
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error aaya');
    } finally { setSavingBiz(false); }
  };
  const handleAddBillField = () => {
    setBillFields([...billFields, { label: '', type: 'percent', value: '0' }]);
  };

  const handleBillFieldChange = (index, key, val) => {
    const updated = [...billFields];
    updated[index][key] = val;
    setBillFields(updated);
  };

  const handleRemoveBillField = (index) => {
    setBillFields(billFields.filter((_, i) => i !== index));
  };

  const handleSaveBillFields = async () => {
    setSavingBill(true);
    try {
      await authAPI.updateProfile({ ...profileForm, bill_fields: billFields });
      toast.success('Bill fields save ho gayi! ✅');
      const saved = JSON.parse(localStorage.getItem('bhamsa_user') || '{}');
      localStorage.setItem('bhamsa_user', JSON.stringify({ ...saved, bill_fields: billFields }));
      if (onUpdate) onUpdate({ bill_fields: billFields });
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error aaya');
    } finally { setSavingBill(false); }
  };

  return (
    <>
      {/* Profile Button */}
      <div style={{ position: 'relative' }}>
        <div className='profile-box' onClick={() => setOpen(!open)}  style={{
            display: 'flex', alignItems: 'center', gap: 10,
            cursor: 'pointer', padding: '6px 12px',
            background: open ? 'var(--bg3)' : 'transparent',
            borderRadius: 10, transition: 'all 0.2s',
          
          }}
        >
          {/* Avatar */}
          <div style={{
            width: 38, height: 38, borderRadius: '50%',
            background: 'linear-gradient(135deg, var(--accent), var(--accent2))',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontWeight: 700, fontSize: 14, color: '#fff', flexShrink: 0,
          }}>
            {initials}
          </div>
          {/* Name + Shop */}
          <div style={{ textAlign: 'left' }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text)' }}>
              {user?.name || 'Admin'}
            </div>
            <div style={{ fontSize: 11, color: 'var(--text3)' }}>
              {user?.shop_name || 'Shop'}
            </div>
          </div>
          {/* Arrow */}
          <div style={{
            fontSize: 10, color: 'var(--text3)',
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s',
          }}>▼</div>
        </div>

        {/* Dropdown */}
        {open && (
          <div style={{
            position: 'absolute', top: '100%', right: 0,
            marginTop: 8, background: 'var(--bg2)',
            border: '1px solid var(--border)', borderRadius: 10,
            minWidth: 200, zIndex: 100,
            boxShadow: '0 8px 32px rgba(0,0,0,0.4)',
            overflow: 'hidden',
          }}>
            {/* User Info */}
            <div style={{
              padding: '14px 16px',
              borderBottom: '1px solid var(--border)',
              background: 'var(--bg3)',
            }}>
              <div style={{ fontWeight: 600, fontSize: 14 }}>{user?.name}</div>
              <div style={{ fontSize: 12, color: 'var(--text2)', marginTop: 2 }}>
                {user?.email}
              </div>
              <div style={{
                marginTop: 6, fontSize: 11, fontWeight: 600,
                color: subColor,
              }}>
                ● {user?.subscription_status === 'active' ? 'Active Plan'
                  : user?.subscription_status === 'trial' ? 'Trial'
                  : 'Plan Expired'}
              </div>
            </div>

            {/* Menu Items */}
            <div
              onClick={() => { setOpen(false); setShowAccount(true); }}
              style={{
                padding: '12px 16px', cursor: 'pointer',
                display: 'flex', alignItems: 'center', gap: 10,
                fontSize: 13, color: 'var(--text2)',
                transition: 'all 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.background = 'var(--bg3)'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >
              👤 Account
            </div>

            <div
              onClick={() => { setOpen(false); setShowSettings(true); }}
              style={{
                padding: '12px 16px', cursor: 'pointer',
                display: 'flex', alignItems: 'center', gap: 10,
                fontSize: 13, color: 'var(--text2)',
                borderTop: '1px solid var(--border)',
                transition: 'all 0.15s',
              }}
              onMouseEnter={e => e.currentTarget.style.background = 'var(--bg3)'}
              onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
            >
              ⚙️ Settings
            </div>
          </div>
        )}
      </div>

      {/* ── Account Modal ─────────────────────────────────── */}
      <Modal isOpen={showAccount} onClose={() => setShowAccount(false)} title="👤 Account" size="md">
        
        {/* Plan Info */}
        <div style={{
          background: 'var(--bg3)', borderRadius: 10,
          padding: 16, marginBottom: 20,
        }}>
          <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 10, color: 'var(--text2)' }}>
            📋 Subscription Info
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
            {[
              ['Status', <span style={{ color: subColor, fontWeight: 600 }}>
                {user?.subscription_status === 'active' ? '✅ Active'
                  : user?.subscription_status === 'trial' ? '🔄 Trial'
                  : '❌ Expired'}
              </span>],
              ['Valid Till', user?.subscription_end_date
                ? new Date(user.subscription_end_date).toLocaleDateString('en-IN')
                : '—'],
              ['Shop', user?.shop_name || '—'],
              ['Phone', user?.phone || '—'],
            ].map(([label, value]) => (
              <div key={label} style={{
                background: 'var(--bg2)', borderRadius: 8, padding: 10,
              }}>
                <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 4 }}>
                  {label}
                </div>
                <div style={{ fontSize: 13, fontWeight: 600 }}>{value}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Edit Profile */}
        <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 12, color: 'var(--text2)' }}>
          ✏️ Edit Profile
        </div>
        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Name</label>
            <input className="form-input" value={profileForm.name}
              onChange={e => setProfileForm({...profileForm, name: e.target.value})} />
          </div>
          <div className="form-group">
            <label className="form-label">Shop Name</label>
            <input className="form-input" value={profileForm.shop_name}
              onChange={e => setProfileForm({...profileForm, shop_name: e.target.value})} />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Email</label>
            <input className="form-input" type="email" value={profileForm.email}
              onChange={e => setProfileForm({...profileForm, email: e.target.value})} />
          </div>
          <div className="form-group">
            <label className="form-label">City</label>
            <input className="form-input" value={profileForm.city}
              onChange={e => setProfileForm({...profileForm, city: e.target.value})} />
          </div>
        </div>
        <div className="form-group">
          <label className="form-label">Address</label>
          <input className="form-input" value={profileForm.address}
            onChange={e => setProfileForm({...profileForm, address: e.target.value})} />
        </div>

        <div className="modal-footer">
          <Button variant="ghost" onClick={() => setShowAccount(false)}>Close</Button>
          <Button onClick={handleUpdateProfile} loading={saving}>💾 Save</Button>
        </div>
      </Modal>

      {/* ── Settings Modal ─────────────────────────────────── */}
      <Modal isOpen={showSettings} onClose={() => setShowSettings(false)} title="⚙️ Settings" size="lg">
      <div className="settings-upload-row">
            {/* Shop Logo Upload */}
            <div className="settings-upload-col" style={{ marginBottom: 24 }}>
              <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 14, color: 'var(--text)' }}>
                🏪 Upload Shop Logo
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                {user?.logo
                  ? <img src={BASE_URL + user.logo} alt="logo"
                      style={{ width: 70, height: 70, borderRadius: '50%', objectFit: 'cover', border: '2px solid var(--accent)' }} />
                  : <div style={{ width: 70, height: 70, borderRadius: '50%', background: 'var(--bg3)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28 }}>🏪</div>
                }
                <div>
                  <input type="file" accept="image/*" id="logo-upload"
                    style={{ display: 'none' }} onChange={handleLogoUpload} />
                <label htmlFor="logo-upload" style={{
                    background: 'var(--accent)', color: '#fff',
                    padding: '8px 16px', borderRadius: 8,
                    cursor: 'pointer', fontSize: 13, fontWeight: 600,
                    display: 'inline-block',
                  }}>
                    {logoUploading ? '⏳ Uploading...' : '📷 Choose Logo'}
                  </label>
                  <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 6 }}>
                    JPG, PNG, WEBP • Max 2MB
                  </div>
                </div>
              </div>
            </div>

            {/* UPI QR Upload */}
            <div className="settings-upload-col" style={{ marginBottom: 24 }}>
              <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 14, color: 'var(--text)' }}>
                📱 Upload UPI QR Code
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                {user?.upi_qr
                  ? <img src={BASE_URL + user.upi_qr} alt="UPI QR"
                      style={{ width: 80, height: 80, objectFit: 'cover', border: '2px solid var(--accent)', borderRadius: 8 }} />
                  : <div style={{ width: 80, height: 80, background: 'var(--bg3)',
                      display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, borderRadius: 8 }}>📱</div>
                }
                <div>
                  <input type="file" accept="image/*" id="upi-upload"
                    style={{ display: 'none' }} onChange={handleUpiUpload} />
                  <Button variant="primary" loading={upiUploading}
                    onClick={() => document.getElementById('upi-upload').click()}>
                    📷 Choose QR Code
                  </Button>
                  <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 6 }}>
                    JPG, PNG, WEBP • Max 2MB
                  </div>
                </div>
              </div>
            </div>
        </div>
        {/* Divider */}
        <div style={{ borderTop: '1px solid var(--border)', margin: '20px 0' }} />

        {/* Business Fields */}
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 14, color: 'var(--text)' }}>
            🏢 Business Details (Displayed on Invoice)
          </div>
          {bizFields.map((field, index) => (
            <div key={index} style={{ display: 'flex', gap: 8, marginBottom: 8, alignItems: 'center' }}>
              <input
                className="form-input"
                placeholder="Label (jaise: GST Number)"
                value={field.label}
                onChange={e => handleFieldChange(index, 'label', e.target.value)}
                style={{ flex: 1 }}
              />
              <input
                className="form-input"
                placeholder="Value (jaise: 27XXXXX)"
                value={field.value}
                onChange={e => handleFieldChange(index, 'value', e.target.value)}
                style={{ flex: 1 }}
              />
              <button
                onClick={() => handleRemoveField(index)}
                style={{
                  background: 'var(--danger)', border: 'none', borderRadius: 6,
                  color: '#fff', width: 32, height: 32, cursor: 'pointer', fontSize: 16,
                }}>✕</button>
            </div>
          ))}
          <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
            <Button variant="ghost" onClick={handleAddField}>
              ➕ Add Field
            </Button>
            <Button variant="primary" loading={savingBiz} onClick={handleSaveBizFields}>
              💾 Save 
            </Button>
          </div>
        </div>
        {/* Divider */}
        <div style={{ borderTop: '1px solid var(--border)', margin: '20px 0' }} />

        {/* Bill Fields */}
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 6, color: 'var(--text)' }}>
            🧾 Bill Fields (GST, Discount, Custom Charges)
          </div>
          <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 14 }}>
          These fields will appear on the billing page.
          </div>
          {billFields.map((field, index) => (
            <div className='form-gstr-input' key={index} style={{ display: 'flex', gap: 8, marginBottom: 8, alignItems: 'center' }}>
              <input
                className="form-input input-phone"
                placeholder="Label (jaise: GST, Delivery)"
                value={field.label}
                onChange={e => handleBillFieldChange(index, 'label', e.target.value)}
                style={{ flex: 2 }}
              />
              <select
                className="form-input"
                value={field.type}
                onChange={e => handleBillFieldChange(index, 'type', e.target.value)}
                style={{ flex: 1 }}
              >
                <option value="percent">% Percent</option>
                <option value="fixed">₹ Fixed</option>
              </select>
              <input
                className="form-input"
                placeholder="Value"
                value={field.value}
                onChange={e => handleBillFieldChange(index, 'value', e.target.value)}
                style={{ flex: 1 }}
              />
              <button
                onClick={() => handleRemoveBillField(index)}
                style={{
                  background: 'var(--danger)', border: 'none', borderRadius: 6,
                  color: '#fff', width: 32, height: 32, cursor: 'pointer', fontSize: 16,
                }}>✕</button>
            </div>
          ))}
          <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
            <Button variant="ghost" onClick={handleAddBillField}>
              ➕ Add Field
            </Button>
            <Button variant="primary" loading={savingBill} onClick={handleSaveBillFields}>
              💾 Save
            </Button>
          </div>
        </div>

        {/* Divider */}
        <div style={{ borderTop: '1px solid var(--border)', margin: '20px 0' }} />

        {/* Divider */}
        <div style={{ borderTop: '1px solid var(--border)', margin: '20px 0' }} />

        {/* Change Password */}
        <div style={{ marginBottom: 24 }}>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 14, color: 'var(--text)' }}>
            🔒 Change Password
          </div>
          <div className="form-group">
            <label className="form-label">Old Password</label>
            <input className="form-input" type="password"
              placeholder="Current password"
              value={passForm.old_password}
              onChange={e => setPassForm({...passForm, old_password: e.target.value})} />
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">New Password</label>
              <input className="form-input" type="password"
                placeholder="Min 6 characters"
                value={passForm.new_password}
                onChange={e => setPassForm({...passForm, new_password: e.target.value})} />
            </div>
            <div className="form-group">
              <label className="form-label">Confirm Password</label>
              <input className="form-input" type="password"
                placeholder="Confirm Password"
                value={passForm.confirm_password}
                onChange={e => setPassForm({...passForm, confirm_password: e.target.value})} />
            </div>
          </div>
          <Button onClick={handleChangePassword} loading={saving} variant="primary">
            🔒 Update Password
          </Button>
        </div>

        {/* Divider */}
        <div style={{ borderTop: '1px solid var(--border)', margin: '20px 0' }} />

        {/* Change Phone */}
        <div>
          <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 14, color: 'var(--text)' }}>
            📱 Change Phone Number
          </div>
          <div className="form-row">
            <div className="form-group">
              <label className="form-label">Phone Number</label>
              <input className="form-input"
                placeholder="10-digit number"
                maxLength={10}
                value={phoneForm.phone}
                onChange={e => setPhoneForm({...phoneForm, phone: e.target.value})} />
            </div>
            <div className="form-group">
              <label className="form-label">WhatsApp Number</label>
              <input className="form-input"
                placeholder="WhatsApp number"
                maxLength={10}
                value={phoneForm.whatsapp}
                onChange={e => setPhoneForm({...phoneForm, whatsapp: e.target.value})} />
            </div>
          </div>
          <Button onClick={handleChangePhone} loading={saving} variant="primary">
            📱 Update Phone Number
          </Button>
        </div>

        <div className="modal-footer">
          <Button variant="ghost" onClick={() => setShowSettings(false)}>Close</Button>
        </div>
      </Modal>

      {/* Backdrop */}
      {open && (
        <div
          style={{ position: 'fixed', inset: 0, zIndex: 99 }}
          onClick={() => setOpen(false)}
        />
      )}
    </>
  );
};

export default ProfileDropdown;